import { useLang } from '@/i18n';
import EfCardsAppA from '@elem/ui/ef-cards-app-a';
import EfLink from '@elem/ui/ef-link';
import EfTitle from '@elem/ui/ef-title';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import styles from './index.module.scss';

export default function TheComp() {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('theProduct.TabA');
    const { pageStatus } = useProductStore();
    const isStatusNext = pageStatus !== IPageStatus.statusA;

    const listA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724571433564/t1.png',
            title: t('win1_a_title'),
            desc: t('win1_a_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724571433722/t2.png',
            title: t('win1_b_title'),
            desc: t('win1_b_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724571433896/t3.png',
            title: t('win1_c_title'),
            desc: t('win1_c_desc'),
        },
    ];
    const linkObj: any = {
        us: 'https://www.ecoflow.com/us/support/download/index',
        ca: 'https://www.ecoflow.com/ca/support/download/index',
        eu: 'https://www.ecoflow.com/eu/support/download/index',
        uk: 'https://www.ecoflow.com/uk/support/download/index',
        de: 'https://www.ecoflow.com/de/support/download/index',
        fr: 'https://www.ecoflow.com/fr/support/download/index',
        it: 'https://www.ecoflow.com/it/support/download/indexx',
        es: 'https://www.ecoflow.com/es/support/download/index',
    };
    const hrefA = linkObj[locale] || linkObj['us'];
    const dataLayerA = [
        {
            event: 'uaEvent',
            event_name: 'jump_button',
            position: t('win1_title'),
            button_name: t('win1_btn'),
            url: hrefA,
        },
    ];

    return (
        <div className={styles.Win1}>
            <EfTitle hasAnimation={false}>{t('win1_title')}</EfTitle>
            <EfCardsAppA list={listA} />
            {isStatusNext && (
                <EfLink className="Win1-btn" href={hrefA} dataLayer={dataLayerA}>
                    {t('win1_btn')}
                </EfLink>
            )}
        </div>
    );
}
